export default __webpack_public_path__ + "static/media/icon-arrow-triangle-up.e23ee821.svg";